<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 1a7.008 7.008 0 0 1 7 7 6.925 6.925 0 0 1-1.4 4.19l2.134 2.136a.943.943 0 0 1-.091 1.322c-.196.2-.463.314-.743.32a.81.81 0 0 1-.58-.23l-2.134-2.134A6.927 6.927 0 0 1 8 15a6.969 6.969 0 0 1-2.246-.37l1.794-1.649A5.007 5.007 0 0 0 13 8.001a5.006 5.006 0 0 0-5.415-4.983l-1.81-1.655A6.966 6.966 0 0 1 8 1Zm-4.171.724 6.741 5.9a.5.5 0 0 1 0 .753l-6.741 5.9A.5.5 0 0 1 3 13.9L2.999 10H0V6h2.999L3 2.1a.5.5 0 0 1 .829-.376Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering145',
});
</script>
